const { createImage, duplicateImage } = require('./Image');

const basePlayer = {
  _version: 3,
  uid: '', // In old objects, this is the same as player.
  player: '', // auth uid
  email: '',
  password: '',
  twitter: '',
  instagram: '',
  reddit: '',
  checkTOS: false,
  checkSubscribe: false,
  image: createImage(),
  created: '',
  updated: '',
};

const createPlayer = (overrides = {}) => ({
  ...basePlayer,
  ...overrides
});

const duplicatePlayer = player => ({
  ...player,
  image: duplicateImage(player.image)
});

module.exports = {
  createPlayer,
  duplicatePlayer
};
